import Plugin from "@wielink/datatables/Plugins/Plugin";

class EditModal extends Plugin {
    init() {
        this.$table.on('click', '[data-dt-btn="openEditModal"]', this.openEditModal.bind(this));
    }

    openEditModal(event) {
        event.preventDefault();

        let modelId = $(event.target).data('modelId');
        if(!modelId) {
            return;
        }
        this.$table.trigger('editModal', {modelId: modelId});
    }

}

export default EditModal;
